import { SelectContainer, SelectOption } from "../../../common/FancySelect";
import { FONT_SIZE } from "../../../../constants/Styles";
import React, { useState } from "react";
import { AddFootprintContainer } from "./AddFootprintAssociationStyles";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import usePart from "../../../../utils/hooks/commonly-stored/parts";
import AddExistingFootprint from "./AddExisting";

enum AddAssociationTab {
  FROM_EXISTING = "From existing footprints",
  NEW = "From new footprint",
}

function NotAvailableYet() {
  return "This feature is not yet available! Sorry...";
}

export function AddFootprintAssociationModal({
  partId,
  isOpen,
  closeModal,
}: {
  partId: string;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { part } = usePart(partId);

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <ModalContentWithCloseButton
        fullScreen
        closeModal={closeModal}
        title={`Add footprint for ${part?.name || "part"}`}
      >
        <AddFootprintAssociation onAdd={closeModal} partId={partId} />
      </ModalContentWithCloseButton>
    </Modal>
  );
}

export default function AddFootprintAssociation({
  partId,
  onAdd,
}: {
  partId: string;
  onAdd: () => void;
}) {
  const [associationTab, setAssociationTab] = useState(
    AddAssociationTab.FROM_EXISTING,
  );

  return (
    <AddFootprintContainer>
      <SelectContainer>
        {Object.values(AddAssociationTab).map((tab) => {
          return (
            <SelectOption
              key={tab}
              isSelected={tab === associationTab}
              onClick={() => setAssociationTab(tab)}
              fontSize={FONT_SIZE.size16}
            >
              {tab}
            </SelectOption>
          );
        })}
      </SelectContainer>
      {associationTab == AddAssociationTab.FROM_EXISTING && (
        <AddExistingFootprint partId={partId} onAdd={onAdd} />
      )}
      {associationTab == AddAssociationTab.NEW && <NotAvailableYet />}
    </AddFootprintContainer>
  );
}
